export interface MonthFilterType {
  month: moment.Moment;
}

export const initialMonthFilter: MonthFilterType = {
  month: undefined,
};
